function pickOneData(obj, key) {
  if (obj.hasOwnProperty(key)) {
    return { [key]: obj[key] };
  } else {
    return { error: `Property '${key}' not found in the object.` };
  }
}

export default pickOneData;
